interface ToastOptions {
  title?: string
  description?: string
  variant?: "default" | "destructive"
  className?: string
}

const useToast = () => {
  const toast = (options: ToastOptions) => {
    // Implement toast logic
    console.log(options);
  };

  return {
    toast,
  };
};

export { useToast };
